import { render, staticRenderFns } from "./long-title-business.vue?vue&type=template&id=cabaa4ea&scoped=true"
import script from "./long-title-business.vue?vue&type=script&lang=js"
export * from "./long-title-business.vue?vue&type=script&lang=js"
import style0 from "./long-title-business.vue?vue&type=style&index=0&id=cabaa4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabaa4ea",
  null
  
)

export default component.exports